import { forwardRef } from 'react';

import { InputLabel } from '@/components/input-label';

import styles from './Input.module.css';

interface InputProps {
  onChange?: (input: TypeAny) => TypeAny;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  type?: Component.Input.Type;
  placeholder?: string | null;
  children?: React.ReactNode;
  required?: boolean;
  disabled?: boolean;
  checked?: boolean;
  pattern?: string;
  accept?: string;
  defaultValue?: string;
  value?: string;
  label?: string | React.ReactNode;
  name: string;
}

const Input = forwardRef(
  (
    {
      type = 'text',
      placeholder,
      children,
      disabled,
      required,
      onChange,
      onKeyDown,
      pattern,
      checked,
      accept,
      defaultValue,
      value,
      label,
      name
    }: InputProps,
    ref: React.LegacyRef<HTMLInputElement>
  ) => {
    const inputId = `input-${type}-${name}`;

    return (
      <label className={styles.input} htmlFor={inputId} data-type={type}>
        {label && (
          <span className={styles.inputLabel}>
            <InputLabel removeMargin={type === 'checkbox'} required={required} label={label} />
          </span>
        )}

        <input
          placeholder={placeholder || undefined}
          className={styles.inputElement}
          data-has-children={!!children}
          data-testid="inputElement"
          defaultValue={defaultValue}
          onChange={onChange}
          onKeyDown={onKeyDown}
          required={required}
          disabled={disabled}
          pattern={pattern}
          checked={checked}
          accept={accept}
          value={value}
          id={inputId}
          name={name}
          type={type}
          ref={ref}
        />

        {children}
      </label>
    );
  }
);

Input.displayName = 'Input';

export { Input };
